import {
  AboutUsJsonLd,
  AboutUsPageMetadata,
  ContentBlocksById,
} from '@aboutyou/logic-components';
import React from 'react';

export const AboutUs = () => {
  const pageId = 106117; // This is the page ID for the About Us AT page

  return (
    <>
      <AboutUsPageMetadata pageId={pageId} />
      <ContentBlocksById pageId={pageId} />
      <AboutUsJsonLd pageId={pageId} />
    </>
  );
};
